import { useTranslation } from 'react-i18next';
import { BaseActionsGrid, SOSButtonConfig } from "@/core/components/actions";
import { CravingLogCard } from "./CravingLogCard";
import { CigaretteLogCard } from "./CigaretteLogCard";
import { MoodLogCard } from "./MoodLogCard";

interface RapidActionsGridProps {
  onDataUpdate?: () => void;
}

export function RapidActionsGrid({ onDataUpdate }: RapidActionsGridProps) {
  const { t } = useTranslation();

  const sosConfig: SOSButtonConfig = {
    gradientClasses: "bg-gradient-to-br from-amber-500 to-yellow-600",
    hoverGradientClasses: "hover:from-amber-600 hover:to-yellow-700",
    translations: {
      buttonLabel: "mindcotine:actions.sosButton",
      buttonLabelFallback: t('common.rapidactionsgrid.sos_craving', 'SOS Craving'),
      buttonHelp: "mindcotine:actions.sosHelp",
      buttonHelpFallback: t('common.rapidactionsgrid.get_instant_support', 'Get instant support'),
      toastTitle: "mindcotine:actions.supportAvailable",
      toastTitleFallback: t('common.rapidactionsgrid.support_available', 'Support Available'),
      toastDescription: "mindcotine:actions.supportOpening",
      toastDescriptionFallback: t('common.rapidactionsgrid.opening_support_chat', 'Opening support chat to help with your craving.'),
    },
    analyticsEvent: t('common.rapidactionsgrid.sos_craving_help', 'SOS Craving Help'),
  };

  return (
    <BaseActionsGrid
      titleKey="mindcotine:actions.title"
      titleFallback="Quick Actions"
      sosConfig={sosConfig}
    >
      <CravingLogCard onDataUpdate={onDataUpdate} />
      <CigaretteLogCard onDataUpdate={onDataUpdate} />
      <MoodLogCard onDataUpdate={onDataUpdate} />
    </BaseActionsGrid>
  );
}
